import Alpine from 'alpinejs'
import { convertObjectNumbersToString } from '../helpers/convertObjectNumbersToString'
import { pushDataLayer } from '../helpers/pushDataLayer'
import { Endpoints } from '../site'
import countries from '../countryCodes.json'

// Initial data, used to reset the form.
const initialFormData = () => ({
  topic: '',
  receiver: '',
  first_name: '',
  last_name: '',
  phone_country_code: '+45',
  phone: '',
  email: '',
  company: '',
  body: '',
  accept_term: false,
  recaptcha_token: '',
  // Parkering
  parking_space: '',
  parking_from: '',
  // investor
  vp_number: '',
  address: '',
  zipcode: '',
  city: '',
  current_url: '',
})

Alpine.data('contactForm', (topic, receiver, url) => ({
  formData: initialFormData(),
  submitted: false,
  errors: null,
  errorMessage: null,
  topicSelected: '',
  topicDefault: topic,
  receiverDefault: receiver,
  pageName: '',
  currentUrl: url,
  countries: countries,

  submit() {
    const thisData = this
    const isEn = this.currentUrl.includes('jeudan.com')

    if (thisData.formData.topic === '') {
      thisData.formData.topic = thisData.topicDefault
    }
    if (thisData.formData.receiver === '') {
      thisData.formData.receiver = thisData.receiverDefault
    }
    if (thisData.formData.current_url === '') {
      thisData.formData.current_url = thisData.currentUrl
    }
    // google reCaptcha script to get token
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(`${import.meta.env.MIX_RECAPTCHA_SITE_KEY as string}`, { action: 'contact_form' })
        .then(function (token) {
          // token to reCaptcha_token in formData.
          thisData.formData.recaptcha_token = token

          fetch(`${import.meta.env.MIX_API_BASE as string}${Endpoints.contactForm}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(convertObjectNumbersToString(thisData.formData)),
          }).then((response) => {
            if (response.ok) {
              pushDataLayer({
                event: `${thisData.formData.topic}_form`,
                mail: thisData.formData.email,
                phone: `${thisData.formData.phone_country_code} ${thisData.formData.phone}`,
                formSubject: thisData.formData.topic,
                serviceType: thisData.pageName,
                parkingHouse: thisData.formData.parking_space,
              })
              thisData.submitted = true
              thisData.errors = null
              thisData.errorMessage = null
              thisData.formData = initialFormData()
              window.dispatchEvent(
                new CustomEvent('notice', {
                  detail: {
                    type: 'success',
                    text: isEn
                      ? 'Thanks for your message. We’re open Monday to Friday from 8:00 to 17:00 and will get back to you as soon as possible. For urgent assistance, please call us 24/7 on +45 7010 6070.'
                      : 'Tak for din henvendelse. Vi sidder klar ved tasterne på hverdage mellem 8 og 17 – og vender retur hurtigst muligt. Har du akut brug for hjælp, kan du ringe døgnet rundt på 7010 6070.',
                  },
                })
              )
            } else {
              thisData.submitted = false
              response.json().then((data) => {
                thisData.errors = data.errors
                thisData.errorMessage = data.message
                window.dispatchEvent(
                  new CustomEvent('notice', { detail: { type: 'error', text: data.message } })
                )
              })
            }
          })
        })
    })
  },

  init() {},
}))
